import React, { useEffect } from 'react';
import { BRAND_NAME, SUPPORT_EMAIL, SUPPORT_PHONE } from '../api/config';

export default function MaintenancePage({ message }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-parchment flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white border-2 border-forest shadow-stamp p-10 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-clay">Maintenance</p>
        <h1 className="font-serif text-3xl text-forest font-semibold mt-3">{BRAND_NAME}</h1>
        <p className="text-sm text-ink/60 mt-4 leading-relaxed">
          {message || 'We are performing scheduled upgrades. Please check back shortly.'}
        </p>
        <div className="mt-8 text-sm text-ink/70 space-y-1">
          <p><a href={`mailto:${SUPPORT_EMAIL}`} className="text-clay hover:underline">{SUPPORT_EMAIL}</a></p>
          <p><a href={`tel:${SUPPORT_PHONE}`} className="text-clay hover:underline">{SUPPORT_PHONE}</a></p>
        </div>
      </div>
    </div>
  );
}
